export const DEPLOY_WIDGET_TOOLTIPS = {
  profile: {
    leadNotificationEmail:
      "New leads from the widget will be sent to this email address. Use an inbox your team actively monitors so follow-up is not delayed.",
    clinicLogo:
      "Upload the logo patients should see on your form and widget. A simple, high-contrast logo usually reads best.",
    formType:
      "Choose the lead capture experience you want to deploy. Full Form is the standard widget flow, while Embedded iframe Form is designed to sit directly inside a page layout.",
    defaultLanguage:
      "Sets the language patients see when the form first opens. Choose the language most visitors should land on by default.",
  },
  formFormat: {
    collectEmail:
      "Adds a required email field to the contact form patients fill in to see their results. Turn this off only if your team follows up by phone alone.",
    collectSmsConsent:
      "Shows an optional checkbox asking patients to agree to receive text messages. It is never required to submit, and the exact wording shown is stored with the lead as your consent record.",
  },
  appearance: {
    previewDevice:
      "Switch between desktop and mobile settings. Position, offsets, and behavior can be configured separately for each view.",
    textContent:
      "This is the CTA message patients see before opening the form. Keep it short, clear, and aligned with the action you want them to take.",
    fontFamily:
      "Choose the font used in the widget where supported. Pick one that feels consistent with your site and stays easy to read.",
    themeColor:
      "Sets the widget's main brand color for buttons and key accents. Use a color that matches your site and still keeps text readable.",
    textColor:
      "Sets the text color used on the widget CTA and related text elements. Make sure it has strong contrast against your theme color.",
    videoPlayFrequency:
      "Controls how often the widget video plays while the widget is visible. Increase this if the preview feels too active.",
    horizontalOffset:
      "Moves the widget horizontally for the current view. Use small values to fine-tune spacing from the screen edge.",
    verticalOffset:
      "Moves the widget vertically for the current view. Use small values to fine-tune its on-screen placement.",
    autoPlayVideo:
      "Choose whether the widget video starts playing automatically when the widget appears in the current view.",
    showCta:
      "Choose whether the CTA starts visible when the page loads for the current view. Turn this off if you want visitors to open it themselves.",
    widgetPosition:
      "Choose whether the widget appears on the left or right side of the screen in the current view.",
    ctaPosition:
      "Choose where the CTA bubble sits relative to the widget. Above stacks it on top, while side places it beside the widget.",
    previewSiteUrl:
      "Paste a page from your site to preview the widget in context. This only affects the preview here and does not change your live website.",
  },
} as const;
